import { useCallback, useContext } from 'react';
import { SharedActionType, SharedContext } from '@core/context';
import { RefreshButtonModel, SiteOrUserModel } from '@shared/models';

export const useSharedFilterState = () => {
  const { state: sharedState, dispatch: sharedDispatch } = useContext(SharedContext);

  const setSitesFilter = useCallback(
    (payload: SiteOrUserModel[]) => {
      sharedDispatch({ type: SharedActionType.SetSites, payload });
    },
    [sharedDispatch]
  );

  const setRefreshButton = useCallback(
    (payload: RefreshButtonModel) => {
      sharedDispatch({ type: SharedActionType.SetRefreshButton, payload });
    },
    [sharedDispatch]
  );

  return {
    sharedState,
    setSitesFilter,
    setRefreshButton,
  };
};
